import { apiService } from '.';
import {
    IExportActivityTimes,
    IRegisterActivityTimes,
} from '../shared/types/activityTimes';

export const asyncGetActivityTimes = async (
    agentIdLog: string,
    date: string,
    page?: number,
    pageSize?: number
) => {
    return await apiService.get('/api/ActivityTime', {
        agentId: agentIdLog,
        date: date,
        limit: pageSize || 20,
        page: page || 0,
    });
};

export const asyncPostActivityTime = async (
    formActivityTime: IRegisterActivityTimes
) => {
    return await apiService.post('/api/ActivityTime', formActivityTime);
};

export const asyncPatchActivityTimes = async (
    id: string,
    formActivityTimes: any
) => {
    return await apiService.put(`/api/ActivityTime/${id}`, formActivityTimes);
};

export const asyncPostActivityTimesExport = async (
    formExport: IExportActivityTimes
) => {
    return await apiService.post('/api/ActivityTime/export', formExport);
};

export const asyncPostDataActivityTimesExport = async (
    formExport: IExportActivityTimes
) => {
    return await apiService.post('/api/ActivityTime/data-export', formExport);
};

export const asyncPatchCloseActivityTimes = async (
    closeActivityTimes?: any
) => {
    return await apiService.put(
        `/api/ActivityTime/close-last-activity`,
        closeActivityTimes
    );
};

export const asyncGetIpOrigin = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json', {
            method: 'GET',
        });
        return response.json();
    } catch (e) {
        const response = await fetch('https://geolocation-db.com/json/', {
            method: 'GET',
        });
        return response.json();
    } finally {
    }
};
